export enum VisionCameraCalibrationsRoutes {
  CreateOne = 'create-one',
  FindMany = 'find-many',
  GetLastCompleted = 'get-last-completed',
  GetOne = 'get-one',
  PlateDistanceDelta = 'plate-distance-delta',
  UpdateOne = 'update-one',
  UploadToSlack = 'upload-to-slack',
}
